import React from 'react';
import { Star } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const TestimonialCard = ({ testimonial }) => {
  return (
    <Card className="h-full hover:shadow-lg transition-all duration-300 border-gray-200">
      <CardContent className="p-6">
        <div className="flex items-start justify-between mb-3">
          <div>
            <h4 className="font-bold text-[#0B2A4A]">{testimonial.name}</h4>
            <p className="text-sm text-gray-600">{testimonial.city}</p>
          </div>
          <div className="flex items-center gap-1">
            {[...Array(testimonial.rating)].map((_, i) => (
              <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
            ))}
          </div>
        </div>
        <p className="text-sm text-gray-700 leading-relaxed mb-3">
          "{testimonial.comment}"
        </p>
        <p className="text-xs text-gray-500">{testimonial.date}</p>
      </CardContent>
    </Card>
  );
};

export default TestimonialCard;
